import "assets/style/colors.scss";
import "assets/style/custom.scss";
import { buildTheme } from "./designSystem";
import { ds } from "./tokens";

// Legge i colori di brand impostati in App.tsx (colors-default.json / colors-nikon.json).
const cssVar = (name: string, fallback: string) => {
  const value = getComputedStyle(document.documentElement)?.getPropertyValue(name)?.trim();
  return value || fallback;
};

export default buildTheme({
  primary: cssVar("--primary-dark", ds.primary),
  primaryHover: cssVar("--primary-hover", ds.primaryHover),
  secondary: cssVar("--primary", ds.primary),
});
